import { render } from "./payment_method_agreement_recurrence.vue?vue&type=template&id=081c8a60"
import script from "./payment_method_agreement_recurrence.vue?vue&type=script&lang=js"
export * from "./payment_method_agreement_recurrence.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__